import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import templateEmptyImage2 from "@/assets/agent-user-detail/template-empty2.webp";

export const TemplateEmpty2Icon = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[templateEmptyImage2]}
      {...props}
    />
  );
};

TemplateEmpty2Icon.displayName = 'TemplateEmpty2Icon';
